import { QueryParameters as SearchQueryParameters } from "@faire/web-api--source/routes/www/search";

export const formatDiscoverSearchTerm = (searchTerm: string): string => {
  // For the /discover/:searchTerm path, we want all spaces to be dashes
  // This is important for SEO, please don't change before speaking with Growth team
  return decodeURIComponent(searchTerm.replace(/-/g, " "));
};

export const parseSearch = (options: {
  search: string | undefined;
  discoverSearchTerm?: string;
}): Record<string, string | undefined> => {
  const query = options.discoverSearchTerm
    ? formatDiscoverSearchTerm(options.discoverSearchTerm)
    : undefined;
  const parsed = SearchQueryParameters.parse(options.search);
  if (!parsed.q) {
    parsed.q = query;
  }
  return parsed;
};
